import { ProductPrice } from "@msdyn365-commerce/retail-proxy";

export function getDiscountBadge(productPrice: ProductPrice | undefined, fallbackBadge: string | undefined): string | undefined {
    if ((!productPrice?.DiscountLines || productPrice.DiscountLines.length === 0) && !fallbackBadge) {
        return;
    }

    const discountLineWithBadge = productPrice?.DiscountLines?.find(x => {
        const matches = x.OfferName?.toLowerCase().match(/\{(.*?)\}/i) || '';
        const parts = matches.length > 1 ? matches[1].split(';').map(x => x.trim()) : undefined;
        return parts?.find(x => x.startsWith('badge:'));
    });

    if (discountLineWithBadge && discountLineWithBadge.OfferName) {
        const offerName = discountLineWithBadge?.OfferName;
        const badge = /\{.*Badge\s*:\s*(.*?)[};]/i.exec(offerName);

        if (badge && badge.length > 1) {
            return badge[1].trim();
        }
    } else if (fallbackBadge) {
        const [startStr, endStr, badge] = fallbackBadge.split(';');
        const now = new Date();
        const isActive = startStr && endStr && badge && new Date(startStr) <= now && new Date(endStr) >= now;

        // If the badge is not active, return undefined
        if (isActive) {
            return badge.trim();
        }
    }

    return undefined;
}